<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
        <p class="font18bold">Pick Course Language</p>
        <div v-if="showSearchLanguage">
            <b-row class="head-box">
                <b-col cols="12" md="6" class="inner-header-box">
                    <div class="light-input-container">
                        <b-input-group class="custom-input-group">
                            <template class="custom-prepend" #prepend>
                                <font-awesome-icon :icon="['fas', 'search']" />
                            </template>
                            <b-form-input @input="queryLanguage" class="custom-control" id="searchInput" v-model="searchInput.name" placeholder="Type in Language"></b-form-input>
                            <template #append>
                                <button :disabled="disableBtn || languages.length === 0" @click="addLang" class="btn btn-grey" type="submit">
                                    <b-icon id="icon-s" font-scale="1" icon="plus"></b-icon>
                                    Add
                                </button>
                            </template>
                            <div class="autocomplete-list" v-if="showDropdown && languages.length !== 0">
                                <ul>
                                    <li @click="selectLang(lang)" v-for="(lang, index) in languages" :key="index"> <img class="mr-2" :src="lang.flag" alt=""> {{ lang.name }}</li>

                                </ul>
                            </div>
                        </b-input-group>
                    </div>
                </b-col>
                <b-col v-if="languageAdded.length > 0" cols="12" md="6" class="p-3 mt-4 mb-4">
                    <span class="country-list-span" v-for="(lang, index) in languageAdded" :key="index">
                      {{lang.name}} <span @click="removeLang(lang)">
                            <b-icon shift-v="-2" font-scale="1.3" icon="x"></b-icon>
                        </span>
                    </span>
                </b-col>
            </b-row>
            <b-form-group class=" col-md-12 mb-3 mt-4" label-for="input-1">
                <button :disabled="disabled || languageAdded.length == 0" @click="proceed" class="float-right btn btn-warning">Proceed
                    <font-awesome-icon :icon="['fas', 'arrow-right']" /> </button>
            </b-form-group>
        </div>
        <div v-if="showLanguageDetails">
            <b-row class="head-box">
                <b-col cols="12" md="6" class="inner-header-box">
                    <div class="light-input-container">
                        <b-input-group class="custom-input-group">
                            <template class="custom-prepend" #prepend>
                                <font-awesome-icon :icon="['fas', 'search']" />
                            </template>
                            <b-form-input @input="queryLanguage" class="custom-control" id="searchInput" v-model="searchInput.name" placeholder="Type in Language"></b-form-input>
                            <template #append>
                                <button @click="addLang" class="btn btn-grey" type="submit">
                                    <b-icon id="icon-s" font-scale="1" icon="plus"></b-icon>
                                    Add
                                </button>
                            </template>
                            <div class="autocomplete-list" v-if="showDropdown && languages.length !== 0">
                                <ul>
                                    <li @click="selectLang(lang)" v-for="(lang, index) in languages" :key="index"> <img class="mr-2" :src="lang.flag" alt=""> {{ lang.name }}</li>
                                </ul>
                            </div>
                        </b-input-group>
                    </div>
                </b-col>
                <b-col v-if="islanguageAdded" class="p-3 mt-4 mb-4">
                    <span class="country-list-span" v-for="(lang, index) in languageAdded" :key="index">
                        {{lang.name}} <span @click="removeLang(lang)">
                            <b-icon shift-v="-2" font-scale="1.3" icon="x"></b-icon>
                        </span>
                    </span>
                </b-col>
            </b-row>
        </div>
        <div class="form-container" v-if="showLanguageDetails">
            <form @submit.prevent="addCourse">
                <p class="font18bold">Language Details</p>
                <div class="row">
                    <b-form-group class="col-md-6 mb-4" label-for="title">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="tag"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input v-model="languageData.title" required type="text" placeholder="Course Title"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="duration">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="clock"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" required v-model="languageData.duration" placeholder="Course Duration e.g 5hrs"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="bridging_language">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="tag"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input v-model="languageData.bridging_language" required type="text" placeholder="Bridging Language"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="fee_status">
                        <b-form-select v-model="languageData.fee_status" required :options="fees"></b-form-select>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="currency" v-if="languageData.fee_status ==='Paid'">
                        <b-form-select v-model="languageData.currency" :options="currencies"></b-form-select>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="amount" v-if="languageData.fee_status ==='Paid'">
                        <b-input-group class="">
                            <b-form-input min="0" type="number" step=".01" v-model="languageData.amount" placeholder="Price Per Student"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mt-2 mb-4" label-for="instructor_bio">
                        <textarea style="height:auto !important" v-model="languageData.instructor_bio" rows="4" placeholder="Instructor Bio" class="card-container form-control"></textarea>
                    </b-form-group>
                    <b-form-group class="col-md-12 mb-3" label-for="course_description">
                        <vue-editor :editor-toolbar="customToolbar" placeholder="Course Description" v-model="languageData.course_description" />
                    </b-form-group>

                </div>
                <p class="font18bold">Modules and Time </p>
                <div class="row desktop">
                    <b-col cols="3">
                        <p> Title</p>
                    </b-col>
                    <b-col cols="3">
                        <p>Start/End date & time</p>
                    </b-col>
                    <b-col cols="3">
                        <p>Location</p>
                    </b-col>
                    <b-col cols="2">
                        <p> File</p>
                    </b-col>
                    <b-col cols="1">
                        <p>Action</p>
                    </b-col>
                </div>
                <div class="row" v-for="(mod, index) in languageData.modules" :key="index">
                    <b-col cols="12">
                        <p>Module {{index+1}}</p>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group class="mb-4" label-for="name">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="tag"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input v-model="mod.title" required type="text" placeholder="Module Title "></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group class="mb-4" label-for="">
                            <date-range-picker @hook:mounted="rangePickerDidMount" @update="hanldeDateSelection(mod)" ref="picker" :date-format="dateFormat" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }" :timePicker="true" :showDropdowns="true" v-model="mod.dateRange">
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </template>
                            </date-range-picker>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-form-group class="mb-4" label-for="address">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="tag"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input v-model="mod.address" required type="text" placeholder="Meeting Link / Address"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="2">
                        <b-form-group class="mb-4 bg-white p-2" label-for="">
                            <b-form-file @change="handleModuleFile(mod,index)" :id="'modulefile'+index" class="mt-3" plain></b-form-file>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="1">
                        <span class="mobile mb-3 font12" style="cursor: pointer" @click="removeModule(index)" v-if="index>=1"> Delete module </span>
                        <b-icon class="desktop" style="cursor: pointer" @click="removeModule(index)" v-if="index>=1" shift-v="-15" icon="trash"></b-icon>
                    </b-col>
                </div>
                <b-row>
                    <b-col>
                        <div @click="addModule" class="btn btn-secondary">+ Add </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-form-group class="col-md-12 mt-4 mb-4" label-for="input-1">
                        <div class="file-container mb-4">
                            <p>Upload Course Avatar</p>
                            <div @click="openFile" class="btn btn-warning">Choose File
                                <b-icon scale="0.8" icon="cloud-arrow-up"></b-icon>
                            </div>
                            <b-form-file @change="showImgName" style="visibility:hidden" id="languageImg" class="mt-3" plain></b-form-file><span>{{imgName}}</span>
                        </div>
                    </b-form-group>
                </b-row>
                <p class="font18bold">Student Preference</p>
                <b-row class="mt-4">
                    <b-form-group class="col-md-6 mb-4" label-for="input-1">
                        <b-input-group class="">
                            <b-form-input type="number" min="1" v-model="languageData.age_limit" placeholder="Age Limit (not under)"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="input-1">
                        <select class="mb-3 custom-select" v-model="languageData.student_nationality_id">
                            <option value="" selected disabled>Please select nationality</option>
                            <option v-for="(country, index) in countries" :key="index" :value="country.country_id">
                                {{ country.name }}
                            </option>
                        </select>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="input-1">
                        <b-input-group class="">
                            <b-form-input type="number" required min="0" v-model="languageData.student_limit" placeholder="Student Limit (No. of total student)"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="input-1">
                        <b-form-select required v-model="languageData.student_gender" :options="genders"></b-form-select>
                    </b-form-group>
                </b-row>

                <b-row class="mt-4">
                    <b-form-group class="col-md-12 mt-2 mb-3" label-for="input-1">
                        <div class="file-container mb-4">
                            <p>Please read the terms and conditons before creating this Language</p>
                            <b-form-checkbox id="termsCheckbox" v-model="terms" required>
                                I accept the <span style="cursor: pointer;" @click="openTerms" class="culture-primary"> terms and conditions</span>
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                    <b-form-group class=" col-md-12 mb-4" label-for="input-1">
                        <button class="float-right btn btn-warning">{{btnText}}
                            <font-awesome-icon :icon="['fas', 'arrow-right']" /> </button>
                    </b-form-group>
                </b-row>
            </form>
            <!-- <div class="text-center" v-if="showPaymentBtn">
                <button @click="completePayment" class="btn btn-secondary">Complete Payment Process</button>
            </div> -->
        </div>
    </b-container>
    <Footer />
</div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
// import VueGoogleAutocomplete from 'vue-google-autocomplete';
import axios from "axios";
import {
    getBaseUrl
} from "../../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'create-language-event',
    components: {
        Header,
        DateRangePicker,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        Footer
    },
    data: function () {
        return {
            headerText: "Instructors",
            subText: "Become a language Instructor",
            fadedText: "Language",
            searchInput: {
                name: '',
                flag: ''
            },
            customToolbar: [
                ["bold", "italic", "underline"],
                [{
                    list: "ordered"
                }, {
                    list: "bullet"
                }]
            ],
            imgName: '',
            languageData: {
                language_id: '',
                filename: '',
                title: '',
                duration: '',
                bridging_language: '',
                course_description: '',
                instructor_bio: '',
                student_gender: null,
                age_limit: '',
                student_limit: '',
                student_nationality_id: '',
                fee_status: null,
                currency: null,
                amount: '',
                modules: [{
                    title: "",
                    address: "",
                    file: '',
                    dateRange: {
                        startDate: new Date().toISOString(),
                        endDate: new Date().toISOString()
                    },
                    startDate: new Date().toISOString(),
                    endDate: new Date().toISOString()
                }],

            },
            isModFileValid: false,
            terms: false,
            btnText: 'Add Course',
            showPaymentBtn: false,
            stripe_url: '',
            fees: [{

                    value: null,
                    text: 'Fee status'
                }, {

                    value: "Free",
                    text: "Free"
                },
                {
                    value: 'Paid',
                    text: "Paid"
                },

            ],
            currencies: [{

                value: null,
                text: 'Select Currency'
            }, {

                value: "USD",
                text: "USD"
            }, ],
            genders: [{
                    value: null,
                    text: 'Please select student gender'
                },
                {
                    value: 'male',
                    text: 'Male'
                },
                {
                    value: 'female',
                    text: 'Female'
                },
                {
                    value: 'other',
                    text: 'Other'
                },
                {
                    value: 'any',
                    text: 'Any'
                },

            ],
            showLanguageDetails: false,
            rangePicker: false,
            showSearchLanguage: true,
            isLanguageAdded: false,
            islanguageAdded: false,
            disabled: true,
            disableBtn: true,
            showDropdown: false,
            languages: [],
            languageAdded: [],
            countries: [],
        }
    },
    filters: {
        date(val) {
            return val ? val.toLocaleString() : ''
        }
    },
    mounted() {
        this.getCountries();
    },
    methods: {
        openTerms() {
            let routeData = this.$router.resolve({
                name: 'terms'
            });
            window.open(routeData.href, "_blank")
        },
        addModule() {
            if (this.languageData.modules === null) {
                this.languageData.modules = [{}];
                return;
            }
            this.languageData.modules.push({
                title: "",
                address: "",
                file: '',
                dateRange: {
                    startDate: new Date().toISOString(),
                    endDate: new Date().toISOString()
                },
                startDate: new Date().toISOString(),
                endDate: new Date().toISOString()
            })
        },
        removeModule(index) {
            this.languageData.modules.splice(index, 1);
        },
        handleModuleFile(mod, index) {
            mod.file = document.getElementById('modulefile' + index).files[0]
            const ext = ['.mp4', '.pdf', '.zip'];
            const valid = ext.some(el => mod.file.name.endsWith(el));
            if (valid) {
                this.isModFileValid = true;
            } else {
                this.$root.$refs.A.makeToast('warning', 'Uploaded file format not supported, only PNG, JPG, ZIP and PDF are allowed')
            }
        },
        hanldeDateSelection(mod) {
            mod.startDate = mod.dateRange.startDate.toISOString();
            mod.endDate = mod.dateRange.endDate.toISOString();
            this.rangePicker = true;
        },
        dateFormat(classes, date) {
            if (!classes.disabled) {
                classes.disabled = date.getTime() < new Date()
            }
            return classes
        },
        addLang() {
            if (this.searchInput.name === '') {
                this.$root.$refs.A.makeToast('danger', 'Add a language')
            } else {
                if (this.languageAdded.length == 1) {
                    this.$root.$refs.A.makeToast('warning', 'You can add only one language')
                } else {
                    this.languageAdded.push({
                        ...this.searchInput
                    })
                    this.isLanguageAdded = true;
                    this.islanguageAdded = true;
                    this.disabled = false;
                    setTimeout(() => this.isLanguageAdded = false, 3000)
                }
            }
        },
        removeLang(lang) {
            this.languageAdded = this.languageAdded.filter(item => item !== lang)
        },
        openFile() {
            document.getElementById('languageImg').click()
        },
        showImgName() {
            const file = document.getElementById('languageImg').files[0];
            this.imgName = file.name
        },
        selectLang(lang) {
            this.searchInput = lang
            if (this.languages.filter(e => e.name === lang.name).length > 0) {
                this.languageData.language_id = lang.language_id
                this.disableBtn = false
            }
            this.showDropdown = false

        },
        async getCountries() {
            try {
                const resp = await axios.get(`${base_url}/api/v2/countries`)
                const country = {
                    country_id: null,
                    name: "Any",
                    namecode: "Any",
                    phonecode: "A"
                };
                const countries = [{
                    ...country
                }, ...resp.data.data];
                this.countries = countries;
            } catch (error) {
                console.warn(error);
            }
        },
        async queryLanguage() {
            const name = this.searchInput.name;
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/languages?name=${name}`,
                    method: "GET",
                })
                this.languages = resp.data.data;
                this.showDropdown = true
            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        proceed() {
            if (this.languageAdded.length == 0) {
                this.$root.$refs.A.makeToast('danger', 'Add a language')
            } else {
                this.showLanguageDetails = true;
                this.showSearchLanguage = false;
            }

        },
        getAddressData: function (_addressData, placeResultData) {
            if (placeResultData.formatted_address !== null) {
                this.address = placeResultData.formatted_address;
            }
        },
        async addCourse() {
            this.btnText = 'Creating Course...'
            const image = document.getElementById("languageImg").files[0]
            let data = new FormData();
            if (image) {
                data.append("images", document.getElementById("languageImg").files[0]);
            }
            data.append('language_id', this.languageData.language_id)
            data.append('title', this.languageData.title)
            data.append('duration', this.languageData.duration)
            data.append('bridging_language', this.languageData.bridging_language)
            data.append('course_description', this.languageData.course_description)
            data.append('instructor_bio', this.languageData.instructor_bio)
            data.append('student_gender', this.languageData.student_gender)
            data.append('age_limit', this.languageData.age_limit)
            data.append('student_limit', this.languageData.student_limit)
            data.append('student_nationality_id', this.languageData.student_nationality_id)
            data.append('fee_status', this.languageData.fee_status)
            if (this.languageData.currency) {
                data.append('currency', this.languageData.currency)
            }
            if (this.languageData.amount) {
                data.append('amount', this.languageData.amount)
            }
            for (let i = 0; i < this.languageData.modules.length; i++) {
                for (let key of Object.keys(this.languageData.modules[i])) {
                    data.append(`modules[${i}][${key}]`, this.languageData.modules[i][key]);
                }
            }
            if (this.terms && this.rangePicker && this.isModFileValid) {
                try {
                    await axios({
                        url: `${base_url}/api/v2/languagecourses`,
                        data: data,
                        method: "POST",

                    })
                    this.btnText = 'Add Course'
                    this.$router.push("/languages/events");
                    // if (resp.data.stripe_onboard_url === null) {
                    //     this.$router.push("/languages/events");
                    // } else {
                    //     this.showPaymentBtn = true;
                    //     this.stripe_url = resp.data.stripe_onboard_url
                    //     this.$root.$refs.A.makeToast('warning', resp.data.message)
                    // }

                } catch (error) {
                    // if (error.response.status == "403") {
                    //     this.showPaymentBtn = true;
                    //     this.stripe_url = error.response.data.stripe_onboard_url
                    // }
                    this.btnText = 'Add Course'
                    this.$root.$refs.A.makeToast('danger', error.response.data.message)
                }
            } else {
                this.btnText = 'Add Course'
                this.$root.$refs.A.makeToast('danger', 'Accept the terms and conditions and select a date range and file for your course')
            }

        },
        // completePayment() {
        //     window.open(this.stripe_url, "_blank")
        // },
        rangePickerDidMount() {
            this.rangePicker = false;
        }
    }

}
</script>

<style scoped>
.row {
    margin-left: 0 !important;
}

.btn-grey {
    background: #565C63 !important;
    border-radius: 4px !important;
    color: #fff !important
}

.light-input-container {
    border: 1px solid rgba(86, 92, 99, 0.54);
    padding: 10px;
    border-radius: 5px;
    background: #fff;
}

.custom-input-group {
    box-shadow: none !important;
    margin: 0 !important
}

.custom-input-group .input-group-prepend {
    padding-top: 18px !important;
}

.btn-culture {
    padding: 10px 60px !important;
}

.form-control {
    height: calc(2em + 0.75rem + 15px) !important;

}

.input-group {
    margin: 0
}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    height: calc(1.5em + 0.75rem + 15px) !important;

}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    background-color: #F6F7F7;
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.font18bold {
    font-size: 18px;
    font-weight: 500;
}

.font24bold {
    font-size: 24px;
    font-weight: 500;
}

.custom-notify {
    border-radius: 8px;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-in-out !important;
}

.country-list-span {
    background: #000;
    color: #fff;
    padding: 15px 30px;
    border-radius: 8px;
    margin-right: 25px;
}

.autocomplete-list {
    top: 62px !important;
    text-align: left !important;
    width: 100% !important
}

.autocomplete-list ul li {
    border: none !important;
    transition: all 0.1s ease-in-out !important;
}

.autocomplete-list ul li:hover {
    background: #F6F7F7;
}

.country-list-span span:nth-child(2) {
    cursor: pointer
}

.autocomplete-list img,
.country-list-span img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}
</style>
